import { createSlice } from "@reduxjs/toolkit";
import identifyService from "../service/identify.service";

const initialState = {
  entity: null,
  isLoading: false,
  error: null,
  isLoggedIn: false,
  dataLoaded: false,
};

const identifySlice = createSlice({
  name: "identify",
  initialState,
  reducers: {
    identifyRequested: (state) => {
      state.isLoading = true;
    },
    identifyReceived: (state, action) => {
      state.entity = action.payload;
      state.dataLoaded = true;
      state.isLoading = false;
    },
    identifyRequestFailed: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    identifyRemoved: (state, action) => {
      state.entity = action.payload;
    },
    authRequested: (state) => {
      state.error = null;
    },
  },
});

const { reducer: identifyReducer, actions } = identifySlice;
const {
  identifyRequested,
  identifyReceived,
  identifyRequestFailed,
  identifyRemoved,
} = actions;

// const identifyUpdateRequested = createAction(
//   "identify/identifyUpdateRequested"
// );
// const identifyUpdateFailed = createAction("identify/identifyUpdateFailed");

export const loadIdentify = () => async (dispatch) => {
  dispatch(identifyRequested());
  try {
    const { content } = await identifyService.getIdentify();
    dispatch(identifyReceived(content));
  } catch (error) {
    dispatch(identifyRequestFailed(error.message));
  }
};

export const deleteIdentify = (payload) => async (dispatch) => {
  dispatch(identifyRequested());
  try {
    const { content } = await identifyService.delete(payload);
    dispatch(identifyRemoved(content));
  } catch (error) {
    dispatch(identifyRequestFailed(error.message));
  }
};
export const getIdentifyById = (groupId) => (state) => {
  if (state.identify.entity) {
    return state.identify.entity.find((u) => u.groupId === groupId);
  }
};

// export const getIdentify = (state) => state.identify.entity;
export const getIdentifyStatus = (state) => state.identify.isLoading;

export const getIdentifyErrors = () => (state) => state.identify.error;

export default identifyReducer;
